const routes = [
  {
    path: 'user',
    component: () => import('@/views/user/UserWrapper.vue'),
    children: [
      {
        path: 'menu',
        name: 'user',
        component: () => import('@/views/user/Menu.vue'),
      },
      {
        path: 'userRequest',
        name: 'UserRequest',
        component: () => import('@/views/user/Menu.vue'),
      },
    ],
  },
];

export default routes;
